import React, { Component } from 'react';
import '../auth.css';

class ResendButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countdown: props.initialCountdown || 60,
      isActive: true
    };
    this.intervalId = null;
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  startCountdown = () => {
    this.setState({ isActive: true });
    
    this.intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.countdown <= 1) {
          clearInterval(this.intervalId);
          return { countdown: 0, isActive: false };
        }
        return { countdown: prevState.countdown - 1 };
      });
    }, 1000);
  };

  handleResend = () => {
    const { onResend, initialCountdown } = this.props;
    
    if (this.state.isActive) {
      return;
    }

    // Reset countdown
    this.setState({ 
      countdown: initialCountdown || 60,
      isActive: true 
    });

    // Call parent's resend handler
    if (onResend) {
      onResend();
    }

    // Start countdown again
    this.startCountdown();
  };

  formatTime = (seconds) => {
    if (seconds >= 60) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
    return `${seconds}s`;
  };

  render() {
    const { countdown, isActive } = this.state;
    const { disabled } = this.props;

    const isDisabled = isActive || disabled;

    // Inline styles to override Bootstrap and global styles
    const buttonStyle = {
      background: 'transparent',
      backgroundColor: 'transparent',
      border: isDisabled ? '2px solid #e0e0e0' : '2px solid #007EA0',
      borderStyle: 'solid',
      borderWidth: '2px',
      color: isDisabled ? '#9E9E9E' : '#007EA0',
      fontSize: '14px',
      fontWeight: '600',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      padding: '10px 20px',
      borderRadius: '8px',
      transition: 'all 0.2s ease',
      display: 'inline-block',
      fontFamily: 'inherit',
      boxShadow: 'none',
      outline: 'none',
      textDecoration: 'none',
      lineHeight: '1.5',
      width: 'auto',
      height: 'auto',
      opacity: isDisabled ? '0.7' : '1'
    };

    const countdownStyle = {
      fontWeight: '700',
      color: '#007EA0'
    };

    return (
      <div className="auth-resend-container" style={{ textAlign: 'center', margin: '20px 0' }}>
        <button
          type="button"
          className={`auth-resend-button ${isDisabled ? 'disabled' : ''}`}
          style={buttonStyle}
          onClick={this.handleResend}
          disabled={isDisabled}
        >
          {isActive ? (
            <>
              Resend code in <span className="auth-resend-countdown" style={countdownStyle}>{this.formatTime(countdown)}</span>
            </>
          ) : (
            'Resend code'
          )}
        </button>
      </div>
    );
  }
}

export default ResendButton;